import _Upload from "@hzero-front-ui/hzero-ui/lib/Upload";
import _Switch from "@hzero-front-ui/hzero-ui/lib/Switch";
import _Slider from "@hzero-front-ui/hzero-ui/lib/Slider";
import _InputNumber from "@hzero-front-ui/hzero-ui/lib/InputNumber";
import _Row from "hzero-ui/lib/row";
import _Col from "hzero-ui/lib/col";
import _Input from "@hzero-front-ui/hzero-ui/lib/Input";
import _Button from "@hzero-front-ui/hzero-ui/lib/Button";
import _Icon from "hzero-ui/lib/icon";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _DatePicker from "@hzero-front-ui/hzero-ui/lib/DatePicker";
import _Select from "@hzero-front-ui/hzero-ui/lib/Select";
import _Form from "@hzero-front-ui/hzero-ui/lib/Form";
var _templateObject;
import React from "react";
import styled from "styled-components";
import intl from "../../../utils/intl";
import { Content, Header } from "../../../components/Page";
var Item = _Form.Item;
var Option = _Select.Option;
var RangePicker = _DatePicker.RangePicker;
var selectAfter = /*#__PURE__*/React.createElement(_Select, {
  defaultValue: ".com",
  style: {
    width: 80
  }
}, /*#__PURE__*/React.createElement(Option, {
  value: ".com"
}, ".com"), /*#__PURE__*/React.createElement(Option, {
  value: ".jp"
}, ".jp"), /*#__PURE__*/React.createElement(Option, {
  value: ".cn"
}, ".cn"), /*#__PURE__*/React.createElement(Option, {
  value: ".org"
}, ".org"));
var StyledDescTitle = styled.h3(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 24px;\n  color: #999;\n"])));
var FormPreview = function FormPreview(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    title: intl.get("hzero.hzeroTheme.page.formPreview").d("表单预览"),
    onBack: props.onBack
  }, /*#__PURE__*/React.createElement(_Button, {
    onClick: props.onExit,
    type: "primary"
  }, /*#__PURE__*/React.createElement(_Icon, {
    type: "logout"
  }), intl.get("hzero.hzeroTheme.page.exitPreview").d("退出预览"))), /*#__PURE__*/React.createElement(Content, {
    style: {
      zIndex: 0
    }
  }, /*#__PURE__*/React.createElement(_Row, {
    gutter: 16
  }, /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.email").d("邮箱")
  }, /*#__PURE__*/React.createElement(_Input, {
    addonAfter: selectAfter,
    defaultValue: 123456
  }))), /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.passwordInput").d("密码输入框"),
    required: true
  }, /*#__PURE__*/React.createElement(_Input, {
    type: "password",
    defaultValue: 123456789
  })))), /*#__PURE__*/React.createElement(_Row, {
    gutter: 16
  }, /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.numberInput").d("数字输入框"),
    required: true
  }, /*#__PURE__*/React.createElement(_InputNumber, {
    defaultValue: 100
  }))), /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.language").d("语言"),
    required: true
  }, /*#__PURE__*/React.createElement(_Select, {
    defalutValue: "1",
    style: {
      width: 120
    }
  }, /*#__PURE__*/React.createElement(Option, {
    value: "1"
  }, "\u7B80\u4F53\u4E2D\u6587"), /*#__PURE__*/React.createElement(Option, {
    value: "2"
  }, "English"), /*#__PURE__*/React.createElement(Option, {
    value: "3"
  }, "\u65E5\u672C\u8BED"))))), /*#__PURE__*/React.createElement(_Row, {
    gutter: 16
  }, /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.startEndDate").d("开始-结束日期"),
    required: true,
    style: {
      height: 56
    }
  }, /*#__PURE__*/React.createElement(RangePicker, {
    placeholder: ["开始日期", "结束日期"],
    style: {
      width: "100%"
    }
  }))), /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.sliderDisplay").d("滑块展示"),
    required: true
  }, /*#__PURE__*/React.createElement(_Slider, {
    defaultValue: 12
  })))), /*#__PURE__*/React.createElement(_Row, {
    gutter: 16
  }, /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.components.switch").d("开关")
  }, /*#__PURE__*/React.createElement(_Switch, null))), /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.components.switch").d("开关")
  }, /*#__PURE__*/React.createElement(_Switch, null)))), /*#__PURE__*/React.createElement(_Row, {
    gutter: 16
  }, /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.uploadAppendix").d("上传附件")
  }, /*#__PURE__*/React.createElement(_Upload, null, /*#__PURE__*/React.createElement(_Button, null, /*#__PURE__*/React.createElement(_Icon, {
    type: "upload"
  }), intl.get("hzero.hzeroTheme.page.uploadAppendix").d("上传附件"))))), /*#__PURE__*/React.createElement(_Col, {
    span: 8
  }, /*#__PURE__*/React.createElement(Item, {
    label: intl.get("hzero.hzeroTheme.page.publishObjectType").d("发布对象类别")
  }, /*#__PURE__*/React.createElement(_Select, {
    mode: "multiple",
    defaultValue: ["1", "2"]
  }, /*#__PURE__*/React.createElement(Option, {
    value: "1"
  }, "\u5BF9\u8C61\u7C7B\u522B1"), /*#__PURE__*/React.createElement(Option, {
    value: "2"
  }, "\u5BF9\u8C61\u7C7B\u522B2"), /*#__PURE__*/React.createElement(Option, {
    value: "3"
  }, "\u5BF9\u8C61\u7D2F\u522B3"), /*#__PURE__*/React.createElement(Option, {
    value: "4"
  }, "\u5BF9\u8C61\u7C7B\u522B4"))))), /*#__PURE__*/React.createElement(_Row, {
    gutter: 16
  }, /*#__PURE__*/React.createElement(_Col, {
    span: 16
  }, /*#__PURE__*/React.createElement(StyledDescTitle, null, intl.get("hzero.hzeroTheme.page.descriptionMessage").d("请输入描述信息"), "\uFF1A"), /*#__PURE__*/React.createElement(_Input.TextArea, {
    placeholder: intl.get("hzero.hzeroTheme.page.descriptionMessage").d("请输入描述信息"),
    rows: 8
  })))));
};
FormPreview.defaultProps = {
  onBack: function onBack() {},
  onExit: function onExit() {}
};
export default FormPreview;